export enum AuthorityInvoice {
  FISCAL_INVOICE_VIEW_CARRIER = '11.1.1',
  FISCAL_INVOICE_CREATE_CARRIER = '11.1.2',
  FISCAL_INVOICE_UPDATE_CARRIER = '11.1.3',
  FISCAL_INVOICE_DELETE_CARRIER = '11.1.4',
  FISCAL_INVOICE_CHANGE_NCM = '4.1.11',
  FISCAL_INVOICE_LIST_VIEW_VALUE = '4.1.12',
  FISCAL_INVOICE_ITEM_DELETE = '4.1.10',
  FISCAL_INVOICE_GENERATE_SPED_FISCAL = '4.3.5',
  FISCAL_INVOICE_EDIT_SPED_FISCAL = '4.3.4',
  FISCAL_INVOICE_DELETE_SPED_FISCAL = '4.3.3',
  FISCAL_INVOICE_ADD_SPED_FISCAL = '4.3.2',
  FISCAL_INVOICE_VIEW_SPED_FISCAL = '4.3.1',
  FISCAL_INVOICE_SPED_FISCAL = '4.3',
  FISCAL_INVOICE_GENERATE_SINTEGRA = '4.2',
  FISCAL_INVOICE_EDIT = '4.1.9',
  FISCAL_INVOICE_DOWNLOAD_XML = '4.1.8',
  FISCAL_INVOICE_PRINT = '4.1.7',
  FISCAL_INVOICE_TRANSMIT = '4.1.6',
  FISCAL_INVOICE_CANCEL = '4.1.5',
  FISCAL_INVOICE_DELETE = '4.1.4',
  FISCAL_INVOICE_REPORT = '4.1.3',
  FISCAL_INVOICE_ADD = '4.1.2',
  FISCAL_INVOICE_VIEW = '4.1.1',
  FISCAL_INVOICE_REGISTRATION = '4.1',
  FISCAL_INVOICE_TAX = '4.',
}
